<template>
  <div>
    <template v-for="(str, vind) in servicesArr">
      <div :key="`str-${vind}`" v-if="vind < limit">
        {{ str }}
      </div>
    </template>
    <div v-if="hasMore">
      <a v-if="!showAll"
           @click.stop="showAll = true"
           class="text-muted small text-lowercase d-block pointer">
        +{{ servicesArr.length - limit }} {{ $t('more_2') }}
      </a>
      <div v-if="showAll">
        <template v-for="(str, vind) in servicesArr">
          <div :key="`strs-${vind}`" v-if="vind >= limit">{{ str }}</div>
        </template>
        <a class="text-muted small text-lowercase d-block pointer"
           @click="showAll = false">
          {{ $t('hide2') }}
        </a>
      </div>
    </div>
    <!--    <div v-if="servicesArr.length > limit"-->
    <!--         :id="`obj-pop-${object.id}`"-->
    <!--         class="text-muted small text-lowercase">-->
    <!--      +{{ servicesArr.length - limit }} {{ $t('more_2') }}-->
    <!--    </div>-->
    <!--    <CustomPopover :target="`obj-pop-${object.id}`"-->
    <!--                   v-if="servicesArr.length > limit"-->
    <!--                   placement="top"-->
    <!--                   ref="popover"-->
    <!--                   :arrow="false">-->
    <!--      <template v-for="(str, vind) in servicesArr">-->
    <!--        <div :key="`strs-${vind}`" v-if="vind >= limit">{{ str }}</div>-->
    <!--      </template>-->
    <!--    </CustomPopover>-->
  </div>
</template>

<script setup>
// import CustomPopover from "@/components/parts/calendar/CustomPopover.vue"
import {computed, ref} from "vue"

const props = defineProps({
  object: {
    type: Object
  }
})

const limit = 4
const showAll = ref(false)
const hasMore = computed(() => servicesArr.value.length > limit)

const servicesArr = computed(() => {
  let grouped = groupBy(props.object.actual_services, 'id')
  let arr = []
  for(const g in grouped) {
    arr.push(`${grouped[g][0].name} [${grouped[g].length}]`)
  }
  return arr
})

const groupBy = (arr, key) => {
  return arr.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
</script>
